<template lang="pug">
  div
    b-row
      .col-xl-7
        panel(:title='$t("ui.member_outstanding")')
          //- b-card
          b-row.mb-2
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              b-breadcrumb.bg-grey-transparent-2.p-l-10
                b-breadcrumb-item(
                  v-for="(item,index) in lines"
                  :key="index"
                  :text="item.account_id"
                  :class="{ active: index==lines.length-1 }"
                  :title="$helpers.getUplineName(item.account_type)"
                  @click="redirectTo(item)"
                )
          b-row
            .col-sm-12.col-md-8.col-lg-9.col-xl-9.mb-1
              b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
            .col-sm-12.col-md-4.col-lg-3.col-xl-3.mb-1
              b-input-group(:prepend="$t('ui.page_size')" size="sm")
                b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="betList" :fields="fields" :per-page="perPage" :filter="filter")
                template(v-slot:cell(index)="row")
                  span {{ row.index + 1 }}
                template(v-slot:cell(account_id)="row")
                  template(v-if="downlineLevel > 2")
                    b-link(@click="redirectTo(row.item)") #[b {{ row.item.account_id.toUpperCase() }}]
                  template(v-else)
                    b-link(@click="redirect(row.item)") #[b {{ row.item.account_id.toUpperCase() }}]
                //- template(v-slot:cell(currency_code)="row")
                //-   currency(:currency="row.item.currency_code")
                template(v-slot:cell(total_bet)="row")
                  span(:class="$helpers.getNumberClass(row.item.total_bet)") #[b {{ row.item.total_bet | currency }} ]
                // template(v-slot:cell(member_bet)="row")
                //   span(:class="$helpers.getNumberClass(row.item.member_bet)") #[b {{ row.item.member_bet | currency }} ]
                // template(v-slot:cell(agent_bet)="row")
                //   span(:class="$helpers.getNumberClass(row.item.agent_bet)") #[b {{ row.item.agent_bet | currency }} ]
                // template(v-slot:cell(company_bet)="row")
                //   span(:class="$helpers.getNumberClass(row.item.company_bet)") #[b {{ row.item.company_bet | currency }} ]
                template(v-slot:bottom-row="row" v-if="showTotal")
                  td.text-right(colspan="2")
                    span #[b {{ $t("ui.grand_total") }} ]
                  td.text-right
                    span(:class="$helpers.getNumberClass(grandTotalBet)")  #[b {{ grandTotalBet | currency }} ]
                  // td.text-right
                  //   span(:class="$helpers.getNumberClass(grandTotalMember)")  #[b {{ grandTotalMember | currency }} ]
                  // td.text-right
                  //   span(:class="$helpers.getNumberClass(grandTotalAgent)")  #[b {{ grandTotalAgent | currency }} ]
                  // td.text-right
                  //   span(:class="$helpers.getNumberClass(grandTotalCompany)")  #[b {{ grandTotalCompany | currency }} ]
</template>

<script>
import SubmitButton from "@/library/SubmitButton.vue"
import currency from "@/components/settings/currency.vue"

export default {
  components: {
    SubmitButton,
    currency
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      downlineLevel: 0,
      betList: [],
      lines: [],
      grandTotalBet: 0,
      grandTotalMember: 0,
      grandTotalAgent: 0,
      grandTotalCompany: 0,
      showTotal: false,
      filter: null,
      sortBy: "account_id",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0
    };
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        // {
        //   key: "currency_code",
        //   label: this.$t("ui.currency"),
        //   class: "align-middle text-center",
        //   thClass: "align-middle bg-grey-lighter",
        //   thStyle: {
        //     width: "10%"
        //   }
        // },
        {
          key: "total_bet",
          label: this.$t("ui.total_bet"),
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        // {
        //   key: "member_bet",
        //   label: this.$t("ui.member"),
        //   class: "align-middle text-right",
        //   thClass: "align-middle bg-grey-lighter",
        //   thStyle: {
        //     width: "10%"
        //   }
        // },
        // {
        //   key: "agent_bet",
        //   label: this.$helpers.getUplineName(this.downlineLevel),
        //   class: "align-middle text-right",
        //   thClass: "align-middle bg-grey-lighter",
        //   thStyle: {
        //     width: "10%"
        //   }
        // },
        // {
        //   key: "company_bet",
        //   label: this.$t("ui.company"),
        //   class: "align-middle text-right",
        //   thClass: "align-middle bg-grey-lighter",
        //   thStyle: {
        //     width: "10%"
        //   }
        // }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function() {
    this.$store.dispatch("user/setSelectedID", this.$store.getters.accountID)
    this.submit()
  },
  methods: {
    redirect: function(account) {
      this.$store.dispatch("user/setSelectedID", account.account_id)
      this.$router.push("/betList")
    },
    redirectTo: function(account) {
      this.$store.dispatch("user/setSelectedID", account.account_id)
      this.submit()
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    submit: function() {
      if (!this.$v.$invalid) {
        let search_id = (this.$store.getters.getSelectedID) ? this.$store.getters.getSelectedID : this.$store.getters.accountID
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        this.loading = true
        this.$store
          .dispatch("user/getStockOutstanding", { search_id, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.clearTotal()
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data.length > 0) {
                this.showTotal = true
                this.betList = response.data

                response.data.forEach(value => {
                  this.grandTotalBet = parseFloat(this.grandTotalBet) + parseFloat(value["total_bet"])
                  this.grandTotalMember = parseFloat(this.grandTotalMember) + parseFloat(value["member_bet"])
                  this.grandTotalAgent = parseFloat(this.grandTotalAgent) + parseFloat(value["agent_bet"])
                  this.grandTotalCompany = parseFloat(this.grandTotalCompany) + parseFloat(value["company_bet"])
                })

                this.lines = response.line
                this.downlineLevel = this.lines[this.lines.length-1].account_type
                this.totalRows = response.data.length > 0 ? this.betList[0]["totalrows"] : 0
              } else {
                this.clearTotal()
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.clearTotal()
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    },
    clearTotal() {
      this.showTotal = false
      this.betList = []
      this.totalRows = 0
      this.grandTotalBet = 0
      this.grandTotalMember = 0
      this.grandTotalAgent = 0
      this.grandTotalCompany = 0
    }
  }
};
</script>
